<div class="mini-leaderboard">
  <div *ngIf="rows.length === 0" class="empty-state">
    <p>No times yet</p>
  </div>

  <div *ngIf="rows.length > 0" class="entries-list">
    <div
      *ngFor="let row of rows; let i = index"
      class="entry-item"
      [class.active]="row.isActive"
      [class.selected]="isSelected(row)"
      (click)="toggleDriver(row)"
    >
      <div class="position">{{ i + 1 }}</div>
      <div class="driver-info">
        <div class="driver-top-row">
          <div class="driver-top-row-left">
            <div class="driver-name">{{ row.driverName }}</div>
            <div class="driver-team" *ngIf="row.teamName">
              {{ row.teamName }}
            </div>
            <span class="driver-status live" *ngIf="row.isActive">
              <span class="status-dot"></span>
              Live
            </span>
            <span
              class="driver-status done"
              *ngIf="!row.isActive && row.isFinished"
            >
              Done
            </span>
          </div>

          <div
            class="entry-time"
            [class.no-time]="row.bestLapTime === undefined"
          >
            {{
              row.bestLapTime !== undefined
                ? formatTime(row.bestLapTime)
                : "No time"
            }}
          </div>
        </div>
        <div class="driver-bottom-row">
          <div class="driver-meta">
            <div class="driver-car" *ngIf="row.carName">{{ row.carName }}</div>
            <div class="driver-irating" *ngIf="row.iRating !== undefined">
              iR {{ row.iRating }}
            </div>
          </div>
          <div class="lap-progress">
            <div>{{ row.lapCount }}/{{ row.targetLaps }} laps</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
